import { CSSProperties } from "@material-ui/core/styles/withStyles";

export const root: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  width: "100%",
  margin: "auto 0",
};

export const loader: CSSProperties = {
  position: "relative",
  width: 70,
  height: 70,
};

export const styles = {
  root,
  loader,
};
